module.exports = __webpack_public_path__ + "img/act_pro_img18s_03.d73feaa6.png";